import { AfterContentInit, AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'app-construction',
  templateUrl: './construction.component.html',
  styleUrls: ['./construction.component.css']
})
export class ConstructionComponent implements AfterContentInit {

  constructor() {

  }

  ngAfterContentInit() {

  }
}
